<h2 mat-dialog-title>Dialog Title</h2>
<mat-dialog-content>
  <p>This is the dialog content.</p>
  <iframe [src]="safeUrl" width="850" height="1000"></iframe>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
